import React, { useEffect } from 'react';
import MyActivePlan from '../../../components/MyPlan/MyActivePlan';
import { useUserContext } from '../../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';

const MyPlan = () => {
  const navigate = useNavigate();
  const { userData } = useUserContext()

  useEffect(() => {
    if (userData?.selectedOrganization?.role?.[0]?.name?.toLowerCase() != 'owner') {
      navigate(`/dashboard`);
    }
  }, [userData?.selectedOrganization])

  return (
    <div className="w-full px-4 md:px-8 my-6">
      <MyActivePlan />
    </div>
  )
}

export default MyPlan;